import { Component, AfterViewInit, HostListener, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-get-demo-form',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './get-demo-form.component.html',
  styleUrls: ['./get-demo-form.component.scss']
})
export class GetDemoFormComponent implements AfterViewInit {
  sectionHeight = window.innerHeight;

  constructor(private el: ElementRef<HTMLElement>) {}

  @HostListener('window:resize')
  onResize() {
    this.sectionHeight = window.innerHeight;
    const section = this.el.nativeElement.querySelector('.section-fullscreen') as HTMLElement | null;
    const cell = this.el.nativeElement.querySelector('.fp-tableCell') as HTMLElement | null;

    if (section && cell) {
      section.style.height = `${this.sectionHeight}px`;
      cell.style.height = `${this.sectionHeight}px`;
    }
  }

  ngAfterViewInit(): void {
    this.onResize();
    this.initFormLogic();
  }

  private initFormLogic(): void {
    const form = this.el.nativeElement.querySelector('.finalForm') as HTMLFormElement | null;
    if (!form) return;

    const questions = Array.from(form.querySelectorAll('ol.questions > li')) as HTMLElement[];
    const nextBtn = form.querySelector('button.next') as HTMLButtonElement | null;
    const progressBar = form.querySelector('.progress') as HTMLElement | null;
    const numberCurrent = form.querySelector('.number-current') as HTMLElement | null;
    const numberTotal = form.querySelector('.number-total') as HTMLElement | null;
    const errorMsg = form.querySelector('.error-message') as HTMLElement | null;
    const submitBtn = form.querySelector('.submit') as HTMLButtonElement | null;

    let current = 0;
    const total = questions.length;
    if (numberTotal) numberTotal.textContent = total.toString();

    const updateProgress = () => {
      if (progressBar && numberCurrent) {
        progressBar.style.width = ((current + 1) / total) * 100 + '%';
        numberCurrent.textContent = (current + 1).toString();

        // Update button text
        if (current === total - 1 && nextBtn) nextBtn.textContent = 'Get Demo';
        else if (nextBtn) nextBtn.textContent = 'Next';
      }
    };

    const showError = (msg: string) => {
      if (errorMsg) {
        errorMsg.textContent = msg;
        errorMsg.classList.add('show');
      }
    };

    const clearError = () => {
      if (errorMsg) errorMsg.classList.remove('show');
    };

    const validate = (input: HTMLInputElement | HTMLSelectElement | null): boolean => {
      if (!input) return true;
      const value = input.value.trim();

      if (!value) {
        showError('Please fill the field before continuing');
        return false;
      }
      if (input.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
        showError('Please enter a valid email address');
        return false;
      }
      clearError();
      return true;
    };

    const nextQuestion = () => {
      const input = questions[current].querySelector('.input') as HTMLInputElement | HTMLSelectElement | null;
      if (!validate(input)) return;

      questions[current].classList.remove('current');
      current++;

      if (current < total) {
        questions[current].classList.add('current');
        updateProgress();
        const nextInput = questions[current].querySelector('.input') as HTMLElement | null;
        nextInput?.focus();
      } else {
        // submit
        form.requestSubmit();
      }
    };

    nextBtn?.addEventListener('click', e => {
      e.preventDefault();
      nextQuestion();
    });

    // handle enter key press
    form.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        nextQuestion();
      }
    });

    form.addEventListener('submit', e => {
      e.preventDefault();

      const formData = new FormData(form);
      const data: Record<string, any> = {};
      formData.forEach((value, key) => (data[key] = value));

      console.log('Form submitted:', data);
      form.classList.add('completed');
      
      alert('Demo request submitted!');
    });

    // init
    questions[0]?.classList.add('current');
    nextBtn?.classList.add('show');
    updateProgress();
  }
}